import BecaService from '@/entities/seguimiento/beca.service';
import { Solicitud } from '@/shared/model/solicitud.model';
import { BModal } from 'bootstrap-vue';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject, Prop, Ref, Watch } from 'vue-property-decorator';
import FiniquitoComponent from '@/entities/seguimiento/finiquito/finiquito.vue';
import HistoricoApoyos from '@/entities/exbecarios/historico-apoyos/historico-apoyos.vue';

@Component({
  components: {
    finiquito: FiniquitoComponent,
    'historico-apoyos': HistoricoApoyos,
  },
})
export default class DatosSolicitudComponent extends Vue {
  @Inject('becaService') public readonly becaService: () => BecaService;

  public isSearching = false;
  public becaId: string | null = null;
  public colSize = '3';

  @Prop({ default: false })
  public solicitud!: Solicitud;

  @Ref('visorFiniquitoModal') visorFiniquitoModal!: BModal;

  @Ref('historicoApoyoModal')
  public readonly historicoApoyoModal!: BModal;
  public cvuExbecario: string | null = '';

  mostrar: boolean;

  public mounted(): void {
    this.retriveBecaSolicitud();
  }

  /**
   * Obtiene la beca en base a la solicitud
   */
  private retriveBecaSolicitud() {
    this.isSearching = true;
    this.becaService()
      .findBySolicitudId(this.solicitud.id)
      .then(beca => {
        if (beca) {
          this.becaId = beca.id;
          if (this.becaId) this.colSize = '2';
        }
      })
      .catch(err => {})
      .finally(() => {
        this.isSearching = false;
      });
  }

  /**
   * Indicador para mostrar o no mostrar el visualizador
   */
  @Watch('mostrar')
  onMostrarChange(newMostrar: boolean): void {
    this.visualizar(newMostrar);
  }

  /**
   * Método para mostrar u ocultar el visualizador
   */
  visualizar(mostrar: boolean): void {
    if (this.visorFiniquitoModal) {
      if (mostrar) {
        (this.visorFiniquitoModal as any).show();
      } else {
        (this.visorFiniquitoModal as any).hide();
      }
    }
  }

  public showModalHistorico(): void {
    this.cvuExbecario = this.solicitud.solicitante?.cvu ?? null;
    this.historicoApoyoModal.show();
  }

  public hideModalHistorico(): void {
    this.cvuExbecario = '';
    this.historicoApoyoModal.hide();
  }
}
